// extracted by mini-css-extract-plugin
module.exports = {"playerHeader":"PlayerHeader_playerHeader__182WG","closeButton":"PlayerHeader_closeButton__2-hmz","navbarLogo":"PlayerHeader_navbarLogo__1OZTn"};